<template>
  <v-container fluid grid-list-md class="pa-0">
    <v-layout row wrap align-center>
      <v-flex class="text-xs-center" xs12 lg12>
        <v-card class="white no-shadow px-2 pt-2 card-r grey lighten-4">
          <v-toolbar class="tow-clor-1 card-r mb-2 shadow-1 pl-3 text-white">
            <v-btn flat :to="'/teacherprofile/'+teacherId+'#calender'" icon class="card-r">
              <v-icon class="text-white left">keyboard_arrow_left</v-icon>
            </v-btn>
            <div class="text-xs-left f-17 text-capitalize">Customize Teacher Schedule</div>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-flex xs12 class="text-xs-left scroll-y" style="height:65vh;">
            <v-tabs class="text-xs-center transparent" slot="extension" v-model="tab" >
              <v-tabs-slider color="unset"></v-tabs-slider>

              <v-tab href="#tab-1" class=" " @click="setSelectedTab(0)">
                <v-avatar color="primary darken-2" size="40px">
                  <span class="f-12 font-weight-regular white--text" >M</span>
                </v-avatar>
              </v-tab>

              <v-tab href="#tab-2" class=" " @click="setSelectedTab(1)">
                <v-avatar color="primary darken-2" size="40px">
                  <span class="f-12 font-weight-regular white--text">T</span>
                </v-avatar>
              </v-tab>

              <v-tab href="#tab-3" class=" "  @click="setSelectedTab(2)">
                <v-avatar color="primary darken-2" size="40px">
                  <span class="f-12 font-weight-regular white--text">W</span>
                </v-avatar>
              </v-tab>
              <v-tab href="#tab-4" class=" " @click="setSelectedTab(3)">
                <v-avatar color="primary darken-2" size="40px">
                  <span class="f-12 font-weight-regular white--text" >T</span>
                </v-avatar>
              </v-tab>

              <v-tab href="#tab-5" class=" " @click="setSelectedTab(4)">
                <v-avatar color="primary darken-2" size="40px">
                  <span class="f-12 font-weight-regular white--text" >F</span>
                </v-avatar>
              </v-tab>

              <v-tab href="#tab-6" class=" " @click="setSelectedTab(5)">
                <v-avatar color="primary darken-2" size="40px">
                  <span class="f-12 font-weight-regular white--text" >S</span>
                </v-avatar>
              </v-tab>
              <v-tab href="#tab-7" class=" " @click="setSelectedTab(6)">
                <v-avatar color="primary darken-2" size="40px">
                  <span class="f-12 font-weight-regular white--text" >S</span>
                </v-avatar>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" class="transparent">
              <v-tab-item  v-for="(index,i) in teacherClasses" :value="'tab-' + (i+1)" :key="i">
                <v-card flat class="transparent no-shadow">
                  <v-flex xs12 class="checkbox pa-0">

                    <v-checkbox
                      v-if="i!=0"
                      label="Repeat the schedule as Monday/First day"
                      required
                      v-model="SameSchedule[i]"
                      @change="setSameSchedule(0,i)"
                    ></v-checkbox>
                  </v-flex>
                  <span class="f-15 textColor font-weight-bold">Add Your Class Schedule</span>
                  <div class="">
                    <v-layout xs12 class="">
                      <v-flex xs4 lg2 class="text-xs-center pa-1">
                        <div class="f-12 font-weight-bold text-primary text-xs-left">Start Hour</div>
                        <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarE-'+i+'-0-A'">
                          <!-- <div v-for="num in 24" :id="'checkNum-'+num" :key="num.id" @mouseover="setHour(num)"> -->
                          <div v-for="num in 24" :id="'checkNum-'+num" :key="num.id" @mouseover="setHour(num)">
                              <!-- <div @mousewheel="Output(num)"> -->
                                {{num-1}}

                              <!-- </div> -->
                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                        <div class="f-12 font-weight-bold text-primary text-xs-left">Min</div>
                        <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarE-'+i+'-0-B'">
                          <div>00</div>
                          <div>15</div>
                          <div>30</div>
                          <div>45</div>
                        </div>
                      </v-flex>
                      <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                        <div class="f-12 font-weight-bold text-primary text-xs-left">Work Min</div>
                        <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarE-'+i+'-0-C'">
                          <div class="">00</div>
                          <div class="">45</div>
                          <div class="">90</div>
                          <div class="">135</div>
                          <div class="">180</div>
                          <div class="">225</div>
                          <div class="">270</div>
                        </div>
                      </v-flex>
                      <!--<v-flex xs1 class=" text-xs-center ">-->
                      <v-avatar :size="25" class="" color="primary darken-2"  v-on:click="counter -= 1">
                        <v-icon dark class="f-8 white--text">close</v-icon>
                      </v-avatar>
                      <!--</v-flex>-->
                    </v-layout>
                    <v-layout>
                      <v-flex>

                        <div v-if="error_in[0][0]==true" style="color:white;background-color:red;padding:5px;">
                          Class time is overlapped
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>

                  <div class=" mt-2 mb-2" v-for="n in counter[i]" :key="n">

                    <v-layout xs12 class="">

                      <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                        <div class="f-12 font-weight-bold text-primary text-xs-left">Start Hour</div>
                        <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarE-'+i+'-'+n+'-A'">
                          <div v-for="num in 24" :id="'checkNum-'+num" :key="num.id" @mouseover="setHour(num)">
                          <!-- <div v-for="i in 24" :key="i.id" @change="hour(i)">{{i}} -->
                            {{num-1}}
                            </div>
                        </div>
                      </v-flex>
                      <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                        <div class="f-12 font-weight-bold text-primary text-xs-left">Min</div>
                        <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarE-'+i+'-'+n+'-B'">
                          <div>00</div>
                          <div>15</div>
                          <div>30</div>
                          <div>45</div>
                        </div>
                      </v-flex>
                      <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                        <div class="f-12 font-weight-bold text-primary text-xs-left">Work Min</div>
                        <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarE-'+i+'-'+n+'-C'">
                          <div class="">00 </div>
                          <div class="">45 </div>
                          <div class="">90 </div>
                          <div class="">135 </div>
                          <div class="">180 </div>
                          <div class="">225</div>
                          <div class="">270</div>
                        </div>
                      </v-flex>
                      <v-avatar :size="25" class="" color="primary darken-2"  v-on:click="counter[i] -= 1">
                        <v-icon dark class="f-8 white--text">close</v-icon>
                      </v-avatar>
                    </v-layout>
                    <v-layout>
                      <v-flex>

                        <div v-if="error_in[i][n]==true" style="color:white;background-color:red;padding:5px;">
                          Class time is overlapped
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>
                  <span class="f-15 textColor font-weight-bold">Add More Schedule</span>
                  <v-layout >
                    <v-flex xs2 class="pa-2">
                      <v-avatar :size="40" color="primary darken-2"  v-on:click="addSlot(i)">
                        <v-icon dark class="f-12 font-weight-regular white--text">add</v-icon>
                      </v-avatar>
                      <br>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
            <v-flex xs12 class="">
              <div class="f-15 textColor text-xs-left font-weight-bold">Duration</div>
              <v-layout xs12 row wrap class="">
                <v-flex xs12 lg4 class="pa-1">
                  <div class="f-12 text-xs-left w-100 text-primary font-weight-bold pa-0">Start Date</div>
                  <Datepiker v-bind:startingDateValue="date_from" v-if="haveDates" v-on:setDate="setStartDate"/>
                </v-flex>
                <v-flex xs12 lg4 class="pa-1">
                  <div class="f-12 text-xs-left w-100 text-primary font-weight-bold">End Date</div>
                  <Datepiker v-bind:startingDateValue="date_to" v-if="haveDates" v-on:setDate="setEndDate"/>
                </v-flex>
                <v-flex lg4 xs12 class="text-xs-right pa-1 pt-5">
                  <v-btn :to="'/teacherprofile/'+teacher_id+'#TeacherClasses'" class="shadow-1 tow-clor-1 card-r text-white">Skip</v-btn>
                  <v-btn @click="checkDates" class="shadow-1 tow-clor-1 card-r right text-white">Update Schedule</v-btn>
                </v-flex>
              </v-layout>
              <v-alert
                :value="true"
                v-if="validationMsg"
                type="info">
                {{validationMsg}}
              </v-alert>
              <v-alert
                :value="true"
                v-if="errorMessage"
                type="error">
                {{errorMessage}}
              </v-alert>
            </v-flex>

          </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    <v-dialog class="pa-0 display-unset" v-model="dialog" width="400">
      <v-card class="card-r no-shadow pa-2">
        <div class="text-xs-center">
          <v-toolbar class="tow-clor-1 card-r mb-2 shadow-1 pl-3 text-white">
                     <span class="f-20">
                        Are you sure Update?
                     </span>
          </v-toolbar>
        </div>
        <v-layout>
          <v-flex>
            <v-layout xs12>
              <v-flex xs12 class="text-xs-right pa-0">
                <v-btn @click="dialog = false" class="tow-clor-grey text-white card-r">Cancel</v-btn>
                <v-btn @click="createSchedule" class="card-r tow-clor-1 text-white card-r">Confirm</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-flex>
          <v-alert
            :value="true"
            v-if="alertType=='success'"
            type="success">
            {{msg}}
          </v-alert>
          <v-alert
            :value="true"
            v-if="alertType=='warning'"
            type="error">
            {{msg}}
          </v-alert>
        </v-flex>
        <v-flex class="text-xs-center pt-9" xs12 sm12 lg9 style="margin:auto">
          <pulse-loader :loading="loading" :color="'#004d98'"></pulse-loader>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  /*eslint-disable*/
  import api from "@/utils/backend-api"
  import router from '@/router'
  import Datepiker from "@/components/pages/Datepicker1"
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import { debuglog } from 'util';

  export default {
    name: "schedule",
    data: () => ({
      tab :null,
      dialog:false,
      counter: 0,
      seen: true,
      show: true,
      date : null,
      birthday: false,
      timeslot: ["07:00 am", "08:00 am" , "09:00 am", "10:00 am" ,"11:00 am", "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm", "04:00 pm", "05:00 pm", "06:00 pm"],
      workMin: ["60 min", "120 min" , "180 min", "240 min" ,"300 min", "360 min", "420 min", "480 min" ],
      breakmin: ["15 min", "30 min" , "45 min", "60 min" ],

      teacherClasses:[
        ["MON",[[]]],
        ["TUE",[[]]],
        ["WED",[[]]],
        ["THU",[[]]],
        ["FRI",[[]]],
        ["SAT",[[]]],
        ["SUN",[[]]],
      ],
      SameSchedule:[],
      counter: {
        0:0,
        1:0,
        2:0,
        3:0,
        4:0,
        5:0,
        6:0,
      },
      scrollPositions:[
        [],
        [],
        [],
        [],
        [],
        [],
        []
      ],
      timeslot: [[[
        {time:"07:00 am",value:'07:00'},
        {time:"07:45 am",value:'08:45'},
        {time:"08:30 am",value:'08:30'},
        {time:"09:15 am",value:'09:15'},
        {time:"10:00 am",value:'10:00'},
        {time:"11:45 pm",value:'11:45'},
        {time:"12:30 pm",value:'12:30'},
        {time:"01:15 pm",value:'01:15'},
        {time:"02:00 pm",value:'02:00'},
        {time:"03:45 pm",value:'03:45'},
        {time:"04:30 pm",value:'04:30'},
        {time:"05:15 pm",value:'05:15'}]]
      ],
      tempValue:'',
      selectedTab:0,
      selectedTime:[],
      date_from:'',
      date_to:'',
      haveDates:false,
      loading:false,
      alertType:'',
      msg:'',
      validationMsg:'',
      errorMessage:'',
      error_in:[
        [],
        [],
        [],
        [],
        [],
        [],
        []
      ],
      teacher_id:''
    }),
    created:function(){
        let teacher_id=this.$route.params.id
        this.teacher_id=teacher_id
        let self=this
        api.getData('admin/calender/teacher/'+teacher_id)
        .then(res=>{
          console.log(res)
          self.date_from=res.data.date_from
          self.date_to=res.data.date_to
          self.haveDates=true
          self.selectedTime=res.data.times

          let time=[[],[],[],[],[],[],[]]
          let days=res.data.days

          for(let x=0;x<days.length;x++){
          //   if(days[x][0])
            let day=days[x][0]
            switch(day){
              case "MON": time[0]=res.data.times[x]
                          break;
              case "TUE": time[1]=res.data.times[x]
                          break;
              case "WED": time[2]=res.data.times[x]
                          break;
              case "THU": time[3]=res.data.times[x]
                          break;
              case "FRI": time[4]=res.data.times[x]
                          break;
              case "SAT": time[5]=res.data.times[x]
                          break;
              case "SUN": time[6]=res.data.times[x]
                          break;
              default:break;
            }
          }

          console.log(time)
          // this.setTimetoTimeSlot(res.data.times)
          self.setTimetoTimeSlot(time)
        }).catch(err=>{
            // this.date_from=""
            // this.date_to=""
            self.haveDates=true
        })
        setTimeout(()=>{
          this.setScrollPositions(this.selectedTab)
        },0);
        console.log("Created")
        // console.log(this.scrollPositions)
        // this.setScrollPositions(this.selectedTab)
    },
    methods:{
        addSlot(i){
          this.saveScrollPositions()
          this.counter[i] += 1
          this.setNewSlotValues(parseInt(this.counter[this.selectedTab]-1))
        },
        setNewSlotValues(i){
          console.log(i)
          // console.log(this.scrollPositions)
          console.log(this.scrollPositions[this.selectedTab][this.counter[i]-1])
          let selectedHourPosition=(this.scrollPositions[this.selectedTab][parseInt(this.counter[this.selectedTab]-1)]).Hour
          let selectedHourValue=selectedHourPosition=("0"+(parseInt((selectedHourPosition+100)/100)-1)).slice(-2)
          let selectedMinPosition=this.scrollPositions[this.selectedTab][this.counter[this.selectedTab]-1].Min
          let selectedMinValue=(parseFloat('0.'+(((parseInt((selectedMinPosition+100)/100))-1)*15)%60).toFixed(2)).substring(2,4)
          let SelectedTime=selectedHourValue+':'+selectedMinValue+":00"
          var datetime = new Date('1970-01-01T' + SelectedTime);
          // let Data=Date.parse(SelectedTime)

          let SelectedWorkMinPosition=this.scrollPositions[this.selectedTab][this.counter[this.selectedTab]-1].workMin
          let selectedWorkMinValue=(parseInt((SelectedWorkMinPosition+100)/100)-1)*45

          let newDateTime= new Date(datetime.getTime() + selectedWorkMinValue*60000);
          let newTime=newDateTime.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'});
          let newHourPosition=((parseInt(newTime.substring(0,2))+1)*100)-100
          let newMinPosition=((newTime.substring(3,5)*100)/15)
          let newPositions={
                  Hour:newHourPosition,
                  Min:newMinPosition,
                  workMin:SelectedWorkMinPosition
                }


          this.scrollPositions[this.selectedTab][this.counter[this.selectedTab]]=newPositions
        },
        setTimetoTimeSlot(times){
          console.log("setTimetoTimeSlot")
          console.log(times.length)
          // times.forEach((element,index)=>{
          //   console.log(element)
          //   // let time=times[x]
          //   this.counter[index]=element.length-1
          //   element.forEach((sch,y)=>{
          //     let time_from={
          //       Hour:sch.time_from.substring(0,2),
          //       Min:sch.time_from.substring(3,5),
          //       workMin:sch.hours
          //     }
          //     let hour=sch.time_from.substring(0,2)

          //     let min=sch.time_from.substring(3,5)
          //     if(min==0){
          //       min=60
          //     }
          //     let position={
          //       Hour:(hour*100)-100,
          //       Min:((min*100)/15)-100,
          //       // type:sch.type,
          //       workMin:((sch.hours*100)/45)-100
          //     }
          //     this.scrollPositions[index].push(position)
          //     // console.log(time_from,position)
          //   })
          // })
          for(let x=0;x<times.length;x++){
            let element=times[x]
            this.counter[x]=element.length==0?0:element.length-1
            console.log(element.length)
            if(element.length>0){
                // element.forEach((sch,y)=>{
                  for(var y=0;y<element.length;y++){
                    let time_from={
                      Hour:parseInt(element[y].time_from.substring(0,2))+1,
                      Min:element[y].time_from.substring(3,5),
                      workMin:element[y].hours
                    }
                    let hour=parseInt(element[y].time_from.substring(0,2))+1

                    let min=element[y].time_from.substring(3,5)
                    // if(min==0){
                    //   min=60
                    // }
                    let position={
                      Hour:(hour*100)-100,
                      Min:((min*100)/15),   // Min:((min*100)/15)-100, <-Old Code
                      workMin:((element[y].hours*100)/45)   // workMin:((element[y].hours*100)/45)-100 <-Old Code
                      // type:element[y].type,
                    }
                    this.scrollPositions[x].push(position)
                    // console.log(time_from,position)

                  }
                // })
            }else{
              let position={
                Hour:0,
                Min:0,
                workMin:0
              }
              this.scrollPositions[x].push(position)
            }
          }


          console.log(this.scrollPositions)
          // this.setScrollPositions(this.selectedTab)
            // for(let y=0;times[x].length;y++){
              // scrollPositions[x][y].push()
              // console.log(times[x][y])

            // }
          // times.forEach((element,index=>{
          //   console.log(element)
          // }))
          // times.forEach((element,index)=>{
          //   this.counter[index]=element.length-1
          //   let value=element.length-1
          //   console.log(value)
          //   for(let m=0;m<value;m++){
          //     console.log(element)
          //     console.log("scrollBarE-"+index+"-"+m+"-A")
          //     var positionHour = document.getElementById('scrollBarE-'+index+"-"+m+"-A");
          //     positionHour.scrollTo(0,200)
          //     // document.getElementById('scrollBarE-'+index+"-"+m+"-A").scrollTop=2000
          //     var positionMin = document.getElementById('scrollBarE-'+index+"-"+m+"-B");
          //     positionMin.scrollTo(0,200)
          //     var positionWorkMin = document.getElementById('scrollBarE-'+index+"-"+m+"-C");
          //     positionWorkMin.scrollTo(0,200)

          //   }
          //   // value.forEach((element)=>{

          //   // })
          // })
      },
      setStartDate(value){
        console.log(value)
        this.date_from=value
      },
      setEndDate(value){
        console.log(value)
        this.date_to=value
      },
      setSelectedTab(num){
        this.setTeacherTime()
        this.saveScrollPositions()
        this.selectedTab=num
        console.log(this.selectedTab)
      },
      setSameSchedule(beforindex,currentindex){
        // debugger
        if(this.SameSchedule[currentindex]==true){
          // this.teacherClasses[currentindex][1]=this.teacherClasses[beforindex][1]
          this.selectedTime[currentindex]=this.selectedTime[beforindex]
          this.scrollPositions[currentindex]=this.scrollPositions[beforindex]
          this.counter[currentindex]=this.counter[beforindex]
        }

        console.log("beforindex: ",beforindex)
        let cnt=this.counter[currentindex]
        setTimeout(()=>{
            for(let x=0;x<=cnt;x++){
              // debugger
                console.log(this.scrollPositions[0][x])
                var positionHour = document.getElementById('scrollBarE-'+currentindex+"-"+x+"-A");
                positionHour.scrollTo(0,this.scrollPositions[0][x].Hour)
                var positionMin = document.getElementById('scrollBarE-'+currentindex+"-"+x+"-B");
                positionMin.scrollTo(0,this.scrollPositions[0][x].Min)
                var positionWorkMin = document.getElementById('scrollBarE-'+currentindex+"-"+x+"-C");
                positionWorkMin.scrollTo(0,this.scrollPositions[0][x].workMin)
                console.log(positionHour.scrollTop,'-',positionMin.scrollTop,'-',positionWorkMin.scrollTop)
            }
        },200);
      },

      setScrollPositions(currentindex){
        // debugger
        let cnt=this.counter[currentindex]
        setTimeout(()=>{
          // debugger
          console.log(this.scrollPositions)
          let self=this
          // if(self.scrollPositions){
            // debugger
            for(let x=0;x<=cnt;x++){
                // debugger
                if(self.scrollPositions[currentindex].length>0){
                  // console.log(self.scrollPositions[currentindex])
                  var positionHour = document.getElementById('scrollBarE-'+currentindex+"-"+x+"-A");
                  positionHour.scrollTo(0,self.scrollPositions[currentindex][x].Hour)
                  var positionMin = document.getElementById('scrollBarE-'+currentindex+"-"+x+"-B");
                  positionMin.scrollTo(0,self.scrollPositions[currentindex][x].Min)
                  var positionWorkMin = document.getElementById('scrollBarE-'+currentindex+"-"+x+"-C");
                  positionWorkMin.scrollTo(0,self.scrollPositions[currentindex][x].workMin)
                  console.log(positionHour.scrollTop,'-',positionMin.scrollTop,'-',positionWorkMin.scrollTop)
                }
            }
          // }
        },500);
      },
      saveScrollPositions(){
        // debugger
        let currentTab=this.selectedTab
        let arr=[]
        // for(let y=0;y<7;y++){
          arr=[]
          let count=this.counter[currentTab]
          for(let x=0;x<=count;x++){
            var positionHour = document.getElementById('scrollBarE-'+currentTab+"-"+x+"-A");
            var positionMin = document.getElementById('scrollBarE-'+currentTab+"-"+x+"-B");
            var positionWorkMin = document.getElementById('scrollBarE-'+currentTab+"-"+x+"-C");
            let positions={
              Hour:positionHour.scrollTop,
              Min:positionMin.scrollTop,
              workMin:positionWorkMin.scrollTop,
            }
            arr.push(positions)
            this.scrollPositions[currentTab]=arr
          }
        // }
        console.log(this.scrollPositions)
      },
      setHour(num){
          // console.log(num)
          this.tempValue=num
      },
      setTeacherTime(){
          // for(let i=0;i<7;i++){
          // console.log("selected tab: "+this.selectedTab)
          let i=this.selectedTab
          let tempTime=[]
          for(let x=0;x<=this.counter[i];x++){
            try{
              var positionHour = document.getElementById('scrollBarE-'+i+"-"+x+"-A");
              var positionMin = document.getElementById('scrollBarE-'+i+"-"+x+"-B");
              var positionWorkMin = document.getElementById('scrollBarE-'+i+"-"+x+"-C");
              // console.log((positionWorkMin.scrollTop+100)/100)
              // console.log("scrollBarE-"+i+"-"+x+" position: ",parseInt((position.scrollTop+100)/100))
            // debugger
            let time={
                time_from:("0"+(parseInt((positionHour.scrollTop+100)/100)-1)).slice(-2)+':'+(parseFloat('0.'+(((parseInt((positionMin.scrollTop+100)/100))-1)*15)%60).toFixed(2)).substring(2,4),
                hours:(parseInt((positionWorkMin.scrollTop+100)/100)-1)*45,
                type:'work'
            }
              tempTime.push(time)
            }catch(err){
                  // console.log("No Content")
            }
          }
          this.selectedTime[i]=tempTime
          // console.log(this.selectedTime)
          // console.log('-----------------------')
        // }
        // console.log("\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n");

      },
      checkDates(){
        this.saveScrollPositions()
        console.log("setTeacherTime")
        this.validationMsg=''
        // debugger
        console.log(this.date_from)
        console.log(this.date_to)
        // if(!this.date_from || !this.date_to){
        //   this.dialog=false
        //   this.validationMsg="Please choose date"
        // }else{
          this.dialog=true
        // }
      },
      createSchedule(){
        this.error_in=[[],[],[],[],[],[],[]]
        this.loading=true
        this.alertType=""
        this.msg=""
        this.errorMessage=""
        let teacher_id=this.$route.params.id
        let Data
        if(this.date_to && this.date_from){
          Data ={
            day:['MON','TUE','WED','THU','FRI','SAT','SUN'],
            times:this.selectedTime,
            date_from:this.date_from,
            date_to:this.date_to,
            teacher_id:teacher_id
          }
        }else{
          Data ={
            day:['MON','TUE','WED','THU','FRI','SAT','SUN'],
            times:this.selectedTime,
            teacher_id:teacher_id
          }
        }
        let self=this

        api.postData('admin/calender/teacher/create',Data)
        .then(res=>{
              console.log(res)
              if(res.status==201){
                // this.loading=false
                this.alertType="success"
                this.msg="You have successfully updated schedule"
                this.loading=false
                setTimeout(()=>{
                    this.dialog=false
                },1000);
              }
        }).catch(error=>{
                this.loading=false
                console.log(error)
                // this.msg="Schedule not created"

                // let error=Object.assign({}, err)
                // console.log(error)
                // this.msg=error.config.data

                // let error=Object.assign({}, err)
                // this.errorMessage=
                // console.log(error)
                if (error.response.data.error) {
                  self.dialog=false
                  self.errorMessage=error.response.data.error.message
                }else if(error.response.data.error_in){
                  self.dialog=false
                  let error_in=error.response.data.error_in
                  console.log(error_in)
                  for(let x=0;x<7;x++){
                    for(let y=0;y<=self.counter[x];y++){
                      self.error_in[x].push(false)
                    }
                  }
                  console.log(self.error_in)
                  error_in.forEach((element,index)=>{
                    this.error_in[element.day][element.slot]=true
                  })
                  console.log(self.error_in)
                }
        })


      }
    },
    updated:function(){
      this.setTeacherTime()
      this.setScrollPositions(this.selectedTab)
    },
    components: {
      PulseLoader,
      Datepiker
    }
  };
</script>
<style>
  .list-dbg{
    background: #e6e6e6;
    padding: 10px;
    height: auto;
    border-radius: 12px;
  }
  .time-ssrl{
    padding: 0px 5px 0px 5px;
  }
  ul ::-webkit-scrollbarE {
    display: none;
  }
  .btn-customer{
    margin: 6px 0px 6px 0px !important;
    height: 45px;
    width: 100%;
  }
  .text-white{
    color: #ffffff!important;
  }
  li {
    scroll-snap-stop: always;
  }
  .containerr {
    display: flex;
    padding: 0px !important;
    overflow: auto;
    outline: 1px dashed lightgray;
    flex: none;
  }

  .containerr.x {
    width: 100%;
    height: 128px;
    flex-flow: row nowrap;
  }

  .containerr.y {
    height: 100px;
    flex-flow: column nowrap;
  }
  .y.proximity-scroll-snapping {
    scroll-snap-type: y proximity;
  }
  .containerr > div {
    text-align: center;
    scroll-snap-align: center;
    flex: none;
  }

  .y.containerr > div {
    line-height: 100px;
    font-size: 30px;
    width: 100%;
    height: 100px;
    color: #fff;
  }
  .containerr > div:nth-child(even) {
    background-color: #00479b !important;
    margin-top: 2px;
  }

  .containerr > div:nth-child(odd) {
    margin-top: 2px;
    background-color: #00479b !important;
  }


.list-bg{
  background: #e6e6e6;
  padding: 10px;
  border-radius: 12px;
}
.v-tabs__item{
  padding: 3px 3px !important;
}
  /*.time-srl{*/
    /*height: 30px;*/
    /*font-size: 15px;*/
    /*list-style-type: none;*/
    /*padding: 5px;*/
    /*color: #095697 !important;*/
    /*overflow: scroll;*/
  /*}  */
.time-srl{
  height: 74px;
  z-index: 1;
  font-size: 17px;
  list-style-type: none;
  padding: 25px 5px 25px 5px;
  color: #095697 !important;
  overflow: scroll;
  }
ul ::-webkit-scrollbarE {
  display: none;}
.active{
  vertical-align: middle;
  /*font-size: 15px;*/
  /*font-weight: bold;*/
  align-items: center;
  /*text-align: center;*/
}

/*ul li:active ,hover{*/
  /*font-size: 15px;*/
  /*font-weight: bold;*/
  /*align-items: center;*/
/*}*/
.v-progress-circular{
    margin: 1rem;
}
.card-pop{
   z-index: -4;
   margin-top: -12%;
 }
.v-dialog{
  box-shadow: none!important;
}
.btn-customer{
  margin: 6px 0px 6px 0px !important;
  height: 45px;
  width: 100%;
}
.text-white{
  color: #ffffff!important;
}
  .ccc{
    height: 35px!important;
    width: 94%!important;
    z-index: 0!important;
    border-bottom: 1px solid!important;
    border-top: 1px solid!important;
    left: 10px!important;
    top: 120px!important;
    position: absolute!important;
  }
  .theme--light.v-tabs__bar {
    background-color: transparent!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/teacher/Statistics.vue